import React from "react";
import { useReactToPrint } from "react-to-print";



const Report = () => {
  const componentRef = React.useRef();

  const PrintButton = () => {
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    return <button onClick={handlePrint}>Print</button>;
  };

  const ReportComponent = () => {
    return <div ref={componentRef}><h3 className="text-light text-center">Hello MLGUI</h3></div>;
  };


  
  return (
    <div>
      <h1>PDF Report</h1>
      <ReportComponent />
      <PrintButton />
    </div>
  );
};

export default Report;
